import React from 'react';
import createArtistListRoute from '../utils/artist-list-page';
import ArtistListPage from '../components/common/ArtistListPage';

import {
  selectComposersIsLoading,
  selectNextComposersCursor,
  selectPrevComposersCursor,
  selectComposers,
} from '../selectors/composer';
import * as composerActions from '../actions/composer';

const route = createArtistListRoute({
  artistType: 'composers',
  selectItems: selectComposers,
  selectIsLoading: selectComposersIsLoading,
  selectNextCursor: selectNextComposersCursor,
  selectPrevCursor: selectPrevComposersCursor,
  loadAction: composerActions.loadComposers,
});

const Composers = ({ ...props }) => {
  return <ArtistListPage {...props} />;
};

Composers.onDataFetch = route.onDataFetch;

export default route(Composers);
